
  import {
    Component,
    Prop,
    Vue
  } from "vue-property-decorator";

  @Component({
    name: 'collapse-item',
  })
  export default class CollapseItem extends Vue {
    @Prop({
      default: '标题'
    }) private title!: string;
    @Prop({}) private tips!: string;
    @Prop({default: true}) private defOpen!: boolean;
    private boxHeight = 0;
    private isOpen = this.defOpen;
    private key = Math.floor(Math.random() * 99) + 1;


    private handleOpen() {
      this.isOpen = !this.isOpen
      if (this.isOpen) {
        this.$emit('open')
      } else {
        this.$emit('close')
      }
    }

  }
